import { MutationTree } from "vuex";
import { AdminState } from "./types";

export const mutations: MutationTree<AdminState> = {};
